import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const MotorcycleRacing = () => {
  return (
    <SportsLayoutComp name={'Motorcycle Racing'}/>
  )
}

export default MotorcycleRacing